import React, { Component } from "react";
import PropTypes from "prop-types";
import VolumeSeries from "./VolumeSeries";
import StraightLine from "./StraightLine";

/**
 * Histograma colorido por DIREÇÃO com linha de base em zero. Genérico e
 * neutro — consumido pelo Awesome Oscillator, DIDI Histograma e afins.
 * `yAccessor(d)` deve retornar `{ value, direction }` (`direction`: "up"/"down").
 */
class ColoredHistogramSeries extends Component {
  render() {
    const {
      yAccessor,
      increasingColor,
      decreasingColor,
      strokeZeroLine,
      className,
      ...rest
    } = this.props;

    // VolumeSeries espera { volume, direction }.
    const volumeAccessor = (d) => {
      const h = yAccessor(d);
      if (!h) return undefined;
      return { volume: h.value, direction: h.direction };
    };

    const fill = ({ direction }) =>
      direction === "up" ? increasingColor : decreasingColor;

    return (
      <g className={className}>
        <VolumeSeries
          {...rest}
          yAccessor={volumeAccessor}
          fill={fill}
          baseAt={(xScale, yScale) => yScale(0)}
        />
        <StraightLine yValue={0} stroke={strokeZeroLine} />
      </g>
    );
  }
}

ColoredHistogramSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  increasingColor: PropTypes.string.isRequired,
  decreasingColor: PropTypes.string.isRequired,
  strokeZeroLine: PropTypes.object,
  className: PropTypes.string,
  clip: PropTypes.bool,
  onContextMenu: PropTypes.func,
  onDoubleClick: PropTypes.func,
};

ColoredHistogramSeries.defaultProps = {
  increasingColor: "#00DD00",
  decreasingColor: "#FF0000",
  strokeZeroLine: { color: "#666666", dash: "Solid", width: 1, opacity: 1 },
  className: "react-stockcharts-colored-histogram",
  clip: true,
};

export default ColoredHistogramSeries;
